var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4201 8.99993C16.4201 13.0979 13.098 16.4199 9.00008 16.4199C4.90213 16.4199 1.58008 13.0979 1.58008 8.99993C1.58008 4.90197 4.90213 1.57993 9.00008 1.57993C13.098 1.57993 16.4201 4.90197 16.4201 8.99993Z",
    stroke: "#3D3D3D",
    strokeOpacity: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39174 11.4287V10.8905C8.39174 10.3647 8.51212 10.0893 8.79364 9.70817L9.69238 8.49987C10.1612 7.86973 10.3219 7.56766 10.3219 7.12096C10.3219 6.37255 9.78584 5.89985 9.02131 5.89985C8.27062 5.89985 7.78797 6.34619 7.62722 7.14732C7.61376 7.22604 7.5603 7.26559 7.47955 7.2524L6.63501 7.10778C6.55426 7.09459 6.51426 7.04224 6.52734 6.96315C6.72885 5.7025 7.65414 4.875 9.0486 4.875C10.4962 4.875 11.4749 5.80721 11.4749 7.10741C11.4749 7.73792 11.2476 8.19744 10.7915 8.81476L9.89313 10.0231C9.62508 10.3775 9.54433 10.5613 9.54433 11.0076V11.4276C9.54433 11.5063 9.49087 11.5587 9.41049 11.5587H8.52558C8.44521 11.5601 8.39174 11.5074 8.39174 11.4287ZM8.32483 12.6897C8.32483 12.611 8.37829 12.5586 8.45904 12.5586H9.47816C9.55854 12.5586 9.612 12.6114 9.612 12.6897V13.8189C9.612 13.898 9.55816 13.95 9.47816 13.95H8.45904C8.37791 13.95 8.32483 13.8976 8.32483 13.8189V12.6897Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.a6c748f3fd7678b688adbcefce3d7ed7.svg";
export { ForwardRef as ReactComponent };